// Allows us to call components methods without passing methods down the component tree
import Vue from 'vue';

export default new Vue();
